// en
export const absences = {
  loading: "Loading...",
  error_fetching: "Error fetching leave requests.",
  month_year_format: { month: "long", year: "numeric" },
  legend: {
    validated: "Validated absences",
    not_validated: "Pending absences",
    weekend: "Weekend",
    holiday: "Holiday",
  },
  table: {
    title: "Leave Requests",
    period: "Period",
    status: "Status",
    validated: "✔ Validated",
    pending: "⏳ Pending",
  },
};
